<template>
    <b-card
            title="مدیریت کاربران"
    >
        <b-row>
            <b-col
                    class="table-size"
            >
                <div class="custom-search">
                    <b-row>
                        <div class="filter-row">
                          <b-button
                              class="mb-1 mr-auto ml-1"
                              variant="primary"
                              @click="addUser()"
                          >
                            جدید
                          </b-button>

                            <b-col md="2">
                                <b-form-group
                                        label="عنوان"
                                        label-for="Title"
                                >
                                    <b-form-input
                                            v-model="filterOptions.Title"
                                            autocomplete="off"
                                            @keyup.enter="update(1)"
                                    />
                                </b-form-group>
                            </b-col>

                            <b-col md="2">
                                <b-form-group
                                        label="موبایل"
                                        label-for="Mobile"
                                >
                                    <b-form-input
                                            v-model="filterOptions.Mobile"
                                            autocomplete="off"
                                            type="number"
                                            @keyup.enter="update(1)"
                                    />
                                </b-form-group>
                            </b-col>

                            <b-button
                                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                    class="mb-1 mr-1"
                                    variant="warning"
                                    @click="update(1)"
                            >فیلتر
                            </b-button>

                        </div>
                    </b-row>
                </div>

                <b-table
                        bordered
                        hover
                        striped
                        :items="items"
                        :fields="fields"
                        class="mt-1 mb-2 position-relative"
                        responsive
                        :sort-by="filterOptions.SortBy"
                        :sort-desc="filterOptions.IsDesc"
                        :busy="loading"
                        :no-local-sorting="true"
                        @sort-changed="sortChange"
                >
                    <template #cell(Id)="data">
                        <b-link
                                :to="{ name: 'userDetail', params: { id: data.value }}"
                                class="font-weight-bold"
                        >
                            #{{ data.value }}
                        </b-link>
                    </template>

                    <template #cell(role)="data">
                        <b-badge
                                v-if="data.item.UserRole.Title"
                                variant="primary"
                        >
                            {{ data.item.UserRole.Title }}
                        </b-badge>
                    </template>

                    <template #cell(CreatedAt)="data">
                        {{ data.value | date }}
                    </template>

                    <template #cell(IsMobileActive)="data">
                        <b-badge
                                :variant="data.value ? 'success' : 'warning'"
                        >
                            {{ data.value ? 'فعال' : 'غیرفعال' }}
                        </b-badge>
                    </template>

                    <template #cell(Name)="data">
            <span class="text-nowrap">
              <b-avatar
                      class="mr-1"
                      :src="data.item.Image"
              />
              {{ data.item.Name }} {{ data.item.Family }}
            </span>
                    </template>

                    <template #cell(actions)="data">

                        <div
                                class="text-nowrap"
                        >
                            <b-link @click="showModal(data.item)">
                                <feather-icon
                                        :id="`invoice-row-${data.item.Id}-send-icon`"
                                        icon="EditIcon"
                                        size="16"
                                />
                            </b-link>

                            <feather-icon
                                    icon="ShieldIcon"
                                    size="16"
                                    v-if="$can( 'show','UserRoleManager')"
                                    @click="showAssignModal(data.item)"
                                    class="ml-1"
                            />

                            <!-- پروفایل کامل: اطلاعات، خلاصه‌ی خرید و تاریخچه‌ی سفارش -->
                            <b-link
                                    class="ml-1"
                                    :to="{ name: 'userDetail', params: { id: data.item.Id } }"
                                    title="پروفایل مشتری"
                            >
                                <feather-icon
                                        icon="UserIcon"
                                        size="16"
                                />
                            </b-link>
                        </div>
                    </template>

                    <template #table-busy>
                        <div
                                class="text-center my-2"
                        >
                            <b-spinner
                                    variant="primary"
                                    class="align-middle"
                            />
                            <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
                        </div>
                    </template>

                </b-table>

                <z-pagination
                        :page="filterOptions.Page"
                        :total-rows="totalRows"
                        :loading="loading"
                        @change="update"
                />

            </b-col>

        </b-row>

        <b-modal
                v-model="isShowModal"
                v-if="isShowModal"
                ok-title="ذخیره"
                cancel-title="انصراف"
                cancel-variant="outline-secondary"
                centered
                title="جزئیات کاربر"
                :no-close-on-backdrop="true"
                size="sm"
                @ok="save"
        >
            <b-row class="mt-1 mb-1">
                <b-col md="6">
                    <b-form-group
                            label="موبایل"
                            label-for="Mobile"
                    >
                        <b-form-input
                                id="Mobile"
                                v-model="row.Mobile"
                                autocomplete="off"
                                :disabled="row.Id"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6" v-if="row.Id">
                    <b-form-group
                            label="نقش"
                            label-for="UserRoleId"
                    >
                        <UserRole
                                v-model="row.UserRoleId"
                                :clearable="false"
                                :disabled="true"
                        />
                    </b-form-group>
                </b-col>
              <b-col md="6" v-else></b-col>

                <b-col md="6">
                    <b-form-group
                            label="نام"
                            label-for="Name"
                    >
                        <b-form-input
                                id="Name"
                                v-model="row.Name"
                                autocomplete="off"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group
                            label="نام خانوادگی"
                            label-for="Family"
                    >
                        <b-form-input
                                id="Family"
                                v-model="row.Family"
                                autocomplete="off"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal
                v-model="isShowModal2"
                v-if="isShowModal2"
                ok-title="ذخیره"
                cancel-title="انصراف"
                cancel-variant="outline-secondary"
                centered
                title="تخصیص"
                :no-close-on-backdrop="true"
                size="sm"
                @ok="assign"
        >
            <b-row class="mt-1 mb-1">
                <b-col md="12">
                    <b-form-group
                            label="نقش"
                            label-for="UserRoleId"
                    >
                        <UserRole
                                v-model="rowAssign.Id"
                                :clearable="true"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>
    </b-card>
</template>

<script>

import { VBToggle } from 'bootstrap-vue'
import UserRole from '@/tools/userrole.vue'

export default {
    directives: {
        'b-toggle': VBToggle,
    },
    components: {
        UserRole,
    },
    data() {
        return {
            totalRows: 1000 * 1000,
            loading: false,
            isShowModal: false,
            isShowModal2: false,
            row: {},
            rowAssign: {},
            filterOptions: {
                Title: null,
                Page: 1,
                SortBy: 'Id',
                IsDesc: true,
                Mobile: null,
            },
            fields: [
                {
                    key: 'Id',
                    label: '#',
                    thClass: 'col-width-50',
                    sortable: true,
                },

                {
                    key: 'Name',
                    label: 'نام و نام خانوادگی',
                    sortable: true,
                },
                {
                    key: 'Mobile',
                    label: 'موبایل',
                },
                {
                    key: 'Role',
                    label: 'نقش',
                },
                {
                    key: 'CreatedAt',
                    label: 'تاریخ',
                    sortable: true,
                },
                {
                    key: 'IsMobileActive',
                    label: 'وضعیت',
                },
                {
                    key: 'actions',
                    label: '',
                    thClass: 'col-width-50',
                },
            ],
            items: [],
        }
    },
    created() {
        if (this.$store.state.zirehState.listFilter[this.$options.name]) {
            this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
        }
        this.update()
    },
    methods: {
        sortChange(e) {
            if (e.sortBy) {
                this.filterOptions.SortBy = e.sortBy
                this.filterOptions.IsDesc = e.sortDesc
                this.update(1)
            }
        },
        update(pageNumber) {
            this.loading = true

            this.filterOptions.Page = pageNumber || this.filterOptions.Page

            this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

            this.$http.post(
                this.$api.user.getlist, this.filterOptions,
            )
                .then(res => {
                    this.totalRows = res.totalRow
                    this.items = res.data
                })
                .finally(() => {
                    this.loading = false
                })
        },
        remove(id) {
            this.removeRow(this.$api.user.remove, 'Id', id)
        },
        showAssignModal(row){
            this.rowAssign = { UserId: row.Id,  Id: row.UserRole.Id }
            this.isShowModal2 = true
        },
        showModal(row){
            this.isShowModal = true
            this.row = JSON.parse(JSON.stringify(row))
            this.row.UserRoleId = row.UserRole.Id
        },
        save(){

            this.isShowModal = false

          let url = this.$api.user.add
          if (this.row.Id) {
            url = this.$api.user.update
          }


          this.$http.post(
              url, this.row,
            )
                .then(res => {
                    this.update()
                })
              .catch(() => {
                this.isShowModal = true
              })
        },
        assign(){
            this.isShowModal2 = false
            this.$http.post(
                this.$api.userrole.assign, this.rowAssign,
            )
                .then(res => {
                    this.update()
                })
        },
      addUser() {
        this.row = {
          Name: null, Family: null, Mobile: null
        }
        this.isShowModal = true
      },
    },
}
</script>
